// src/redux/noticeApi.js
import { apiSlice } from "./apiSlice";

export const noticeApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getNoticeList: build.query({
            query: (params) => ({
                url: "/api/user/notice/v1",
                method: "get",
                headers: { token: true },
                params,
            }),
        }),
        getNoticeById: build.query({
            query: (noticeId) => ({
                url: `/api/user/notice/v1/${noticeId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
    }),
});

export const { useGetNoticeListQuery, useGetNoticeByIdQuery } = noticeApi;
